module.exports = __webpack_public_path__ + "static/media/join_full_white_24dp.a6cd8bf0.svg";